module.exports = __webpack_public_path__ + "img/0-03.79d3301f.jpg";